"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _CategoryListItem = _interopRequireDefault(require("./CategoryListItem"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'category-list';
exports.cssAnchorName = cssAnchorName;

var CategoryList = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CategoryList, _Component);

  var _super = _createSuper(CategoryList);

  function CategoryList() {
    (0, _classCallCheck2.default)(this, CategoryList);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(CategoryList, [{
    key: "render",
    value: function render() {
      var _category$children;

      var _this$props = this.props,
          isCommunity = _this$props.isCommunity,
          cdn = _this$props.cdn,
          category = _this$props.category;
      var categories = (_category$children = category.children) !== null && _category$children !== void 0 ? _category$children : [];
      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('category-page_container', {
          'category-page_container--mobile-only': categories.length > 0 && !isCommunity
        })
      }, (0, _preact.h)("ul", {
        className: "category-page_list"
      }, categories.length > 0 && categories.map(function (category) {
        var id = category.id,
            children = category.children;
        return (0, _preact.h)(_CategoryListItem.default, (0, _extends2.default)({
          key: "category-id-".concat(id)
        }, category, {
          categoriesCount: children === null || children === void 0 ? void 0 : children.length,
          showMetadata: true,
          cdn: cdn
        }));
      })));
    }
  }]);
  return CategoryList;
}(_preact.Component);

var _default = CategoryList;
exports.default = _default;